import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import { routes } from "../General";
import axios from "axios";
import { Liquidacion } from "./compModal/Liquidacion";
import { Documentos } from "./compModal/Documentos";
import { Facturas } from "./compModal/Facturas";
import { ContratanteGEN } from "./ContratanteGEN";
import { Gestion } from "./compModal/Gestion";
import { Beneficios } from "./compModal/Beneficios";
import { DocsDigitalTabla } from "./DocsDigitalTabla";

export class DetallesGEN extends Component {
    constructor(props) {
        super(...arguments);
        this.alert = React.createRef();
        this.state = {
            value: "",
            editing: false,
            item: {},
            cliente: {},
            hTabs: "ht0",
            beneficios: [],
            documentos: [],
            facturas: [],
            gestion: [],
            liquidaciones: [],
            docdigital: [],
            docminio: [],
            datos: [],
            coberturas: [],
            totalesBeneficio: [],
            cdCompania: 1,
            cdReclamo: "",
            deducible: {
                total: 1,
                saldo: 1,
                consumido: 0,
            },
            diasExtra: null,
        };
    }

    componentDidUpdate(prevProps) {
        let { open } = this.props;
        let openOld = prevProps.open;

        if (open !== openOld) {
            if (open) {
                this.fetchData();
            } else {
                this.setState({ item: {} });
            }
        }
    }

    onClose = () => {
        this.getDocDigital(this.props.siniestro);
    };

    fetchData() {
        this.getBeneficios(this.props.siniestro.cdCompania, this.props.siniestro.cdReclamo);
        this.getDocumentos(this.props.siniestro.cdCompania, this.props.siniestro.cdReclamo);
        this.getFacturas(this.props.siniestro.cdCompania, this.props.siniestro.cdReclamo);
        this.getLiquidaciones(this.props.siniestro.cdCompania, this.props.siniestro.cdReclamo);
        this.getGestiones(this.props.siniestro.cdCompania, this.props.siniestro.cdReclamo);
        this.getDocDigital(this.props.siniestro);
        this.getPoliza();
    }

    getBeneficios = (idComp, cdReclamo) => {
        axios
            .get(routes.api + "/siniestros-gen/cobertura", {
                params: {
                    cdCompania: idComp,
                    cdReclamo: cdReclamo,
                },
            })
            .then(resp => {
                let bens = resp.data.sort((a1, a2) => a1.cdCobDedSiniestro - a2.cdCobDedSiniestro);

                let totales = {
                    valSiniestro: 0,
                    valExceso: 0,
                    valNoelegible: 0,
                    valCubierto: 0,
                    valDeducible: 0,
                    valFijo: 0,
                };
                bens.forEach(item => {
                    item.valCubierto = item.valSiniestro - item.valMinimo;
                    totales.valSiniestro += item.valSiniestro ? item.valSiniestro : 0;
                    totales.valExceso += item.valExceso ? item.valExceso : 0;
                    totales.valNoelegible += item.valNoelegible ? item.valNoelegible : 0;
                    totales.valCubierto += item.valCubierto ? item.valCubierto : 0;
                    totales.valDeducible += item.valDeducible ? item.valDeducible : 0;
                    totales.valFijo += item.valFijo ? item.valFijo : 0;
                });
                this.setState({ beneficios: bens, totalesBeneficio: totales });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getDocDigital = coti => {
        axios
            .get(routes.api + "/docs", {
                params: {
                    tipo: "siniestrosGen",
                    numSiniestro: coti.numSiniestro,
                    cdCliente: coti.cdCliente,
                    cdPoliza: coti.poliza,
                    cdCompania: coti.cdCompania,
                    cdReclamo: coti.cdReclamo,
                    cdIncSiniestro: 0,
                },
            })
            .then(resp => {
                let res = resp.data;
                res.minio.map(rp => {
                    rp.metadato = JSON.stringify(rp.metadato);
                });
                (res.minio || []).forEach(datosTabla => {
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                    //Se encuentra doble serializado el JSON
                    datosTabla.metadato = JSON.parse(datosTabla.metadato);
                });
                this.setState({ docdigital: res });
            })
            .catch(error => {
                // alert('Error al consultar' + error);
            });
    };

    getDocumentos = (idComp, cdReclamo) => {
        axios
            .get(routes.api + "/siniestros-gen/documentos", {
                params: {
                    cdCompania: idComp,
                    cdReclamo: cdReclamo,
                },
            })
            .then(resp => {
                let docs = resp.data.sort((a1, a2) => parseInt(a1.item) - parseInt(a2.item));
                this.setState({ documentos: docs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getFacturas = (idComp, cdReclamo) => {
        axios
            .get(routes.api + "/siniestros-gen/cargarFactura", {
                params: {
                    cdCompania: idComp,
                    cdReclamo: cdReclamo,
                },
            })
            .then(resp => {
                let facts = resp.data;
                this.setState({ facturas: facts });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getLiquidaciones = (idComp, cdReclamo) => {
        axios
            .get(routes.api + "/siniestros-gen/cargarLiquidacion", {
                params: {
                    cdCompania: idComp,
                    cdReclamo: cdReclamo,
                },
            })
            .then(resp => {
                let liqs = resp.data;
                this.setState({ liquidaciones: liqs });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    getGestiones = (idComp, cdReclamo) => {
        axios
            .get(routes.api + "/siniestros-gen/inspecion", {
                params: {
                    cdCompania: idComp,
                    cdReclamo: cdReclamo,
                },
            })
            .then(resp => {
                let ges = resp.data;
                this.setState({ gestion: ges });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    closeModal = () => {
        this.props.toggleModal(false);
        this.setState({ item: {} });
    };

    getPoliza = () => {
        axios
            .get(routes.api + "" + "/cliente", {
                params: {
                    cdCliente: this.props.siniestro.cdCliente,
                },
            })
            .then(resp => {
                this.setState({ cliente: resp.data });
            })
            .catch(error => {
                alert("Error al consultar" + error);
            });
    };

    render() {
        return (
            <Modal className="text-center modal-xl mx-auto modal-detail " isOpen={this.props.open}>
                <ModalBody>
                    <div className="row">
                        <ContratanteGEN
                            siniestro={this.props.siniestro}
                            cliente={this.state.cliente}
                            diasExtra={this.state.diasExtra}
                        />
                        <div className="col-lg-9 pt-2">
                            <div className={"text-right"}>
                                <button
                                    type="button"
                                    className="close"
                                    title="Cerrar"
                                    onClick={this.closeModal}
                                    aria-label="Close"
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <h5 className="card-title">Detalle Siniestro</h5>
                            <Beneficios
                                beneficios={this.state.beneficios}
                                totales={this.state.totalesBeneficio}
                                vam={false}
                            />
                            <div className="my-1" />
                            <Gestion hTabs={this.state.hTabs} gestion={this.state.gestion} />
                            <div className="my-1" />
                            <Documentos hTabs={this.state.hTabs} documentos={this.state.documentos} />
                            <div className="my-1" />
                            <Facturas hTabs={this.state.hTabs} facturas={this.state.facturas} vam={false} />
                            <div className="my-1" />
                            <Liquidacion hTabs={this.state.hTabs} liquidaciones={this.state.liquidaciones} />
                            <div className="my-1" />
                            <DocsDigitalTabla
                                hTabs={this.state.hTabs}
                                docdigital={this.state.docdigital}
                                docminio={this.state.docminio}
                                dato={this.props.siniestro}
                                tipo={"siniestrosGen"}
                                onClose={this.onClose}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}
